import React from "react";
import { Box, LinearProgress } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";

export interface StickyLoadingBarProps {
  loading?: boolean;
  ariaLabel?: string;
  sx?: SxProps<Theme>;
}

export const StickyLoadingBar = ({ loading = false, ariaLabel = "Loading data", sx }: StickyLoadingBarProps) => {
  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.appBar - 1,
        height: loading ? 4 : 0,
        overflow: "hidden",
        transition: "height 200ms cubic-bezier(0.4, 0, 0.2, 1)",
        ...sx,
      }}
    >
      {loading && (
        <LinearProgress
          role="progressbar"
          aria-label={ariaLabel}
          aria-busy={loading}
          sx={{
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.05)",
          }}
        />
      )}
    </Box>
  );
};
